import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Checkbox from '@/components/custom/Checkbox';
import DatePicker from '@/components/custom/DatePicker';
import Excel from '@/components/custom/Excel';
import EditField from '@/components/custom/EditField';
import Multiselect from '@/components/custom/Multiselect';
import SelectEditField from '@/components/custom/SelectEditField';
import Typeahead from '@/components/custom/Typeahead';
import TypeButtonList from '@/components/custom/TypeButtonList';

export default {
    Checkbox,
    DatePicker,
    Excel,
    EditField,
    Multiselect,
    SelectEditField,
    Typeahead,
    TypeButtonList,
    FontAwesomeIcon,
};